// extracted by mini-css-extract-plugin
export default {"controls":"DescriptionEdit_controls__jb9B-","field":"DescriptionEdit_field__7Bz9W"};